(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!window.lbGuaranteePreferenceLoaded) {
    window.lbGuaranteePreferenceLoaded = true;
    window.lbGuaranteeOptOut = false;

    try {
      window.lbGuaranteeOptOut =
        sessionStorage.getItem('lb-guarantee-opt-out') === '1';
    } catch (error) {}
  }

  window.lbSetGuaranteeOptOut = (value) => {
    window.lbGuaranteeOptOut = value;

    try {
      if (value) {
        sessionStorage.setItem('lb-guarantee-opt-out', '1');
      } else {
        sessionStorage.removeItem('lb-guarantee-opt-out');
      }
    } catch (error) {}
  };

  if (!customElements.get('lb-selection-timer')) {
    customElements.define(
      'lb-selection-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.duration = 600000;

          try {
            this.end =
              Number(
                sessionStorage.getItem('lb-cart-selection-end-v2')
              ) || 0;
          } catch (error) {}

          if (!this.end || this.end <= Date.now()) {
            this.restart();
          }

          this.tick();

          this.interval = window.setInterval(
            () => this.tick(),
            1000
          );
        }

        disconnectedCallback() {
          window.clearInterval(this.interval);
        }

        restart() {
          this.end = Date.now() + this.duration;

          try {
            sessionStorage.setItem(
              'lb-cart-selection-end-v2',
              String(this.end)
            );
          } catch (error) {}
        }

        tick() {
          const remaining = Math.max(
            0,
            Math.ceil((this.end - Date.now()) / 1000)
          );

          const value = this.querySelector(
            '[data-lb-cart-timer]'
          );

          if (value) {
            value.textContent =
              String(Math.floor(remaining / 60)).padStart(2, '0') +
              ':' +
              String(remaining % 60).padStart(2, '0');
          }
        }
      }
    );
  }

  if (!window.lbCartActionsBound) {
    window.lbCartActionsBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest(
        '[data-lb-key][data-lb-quantity], [data-lb-protection]'
      );

      if (!button) return;

      const drawer = button.closest('#cart-drawer');

      if (!drawer || drawer.dataset.lbBusy === 'true') return;

      event.preventDefault();

      window.lbGuaranteeAutoFailed = false;

      drawer.dataset.lbBusy = 'true';
      drawer.setAttribute('aria-busy', 'true');

      const controls = drawer.querySelectorAll(
        '[data-lb-key], [data-lb-protection], button[name="checkout"]'
      );

      const originalDisabled = new Map();

      controls.forEach((control) => {
        originalDisabled.set(control, control.disabled);
        control.disabled = true;
      });

      const errorElement = drawer.querySelector(
        '.lb-cart__error'
      );

      if (errorElement) {
        errorElement.hidden = true;
      }

      const sectionId = drawer.dataset.sectionId;

      const protectionProductId = Number(
        drawer.dataset.protectionProductId
      );

      const root = window.Shopify?.routes?.root || '/';

      let cart;
      let html;
      let changed = false;

      const request = async (path, body) => {
        const response = await fetch(root + path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            ...body,
            sections: [sectionId],
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Não foi possível atualizar o carrinho.'
          );
        }

        return data;
      };

      try {
        let result;

        if (button.hasAttribute('data-lb-protection')) {
          if (button.getAttribute('aria-checked') === 'true') {
            const keys = JSON.parse(
              button.dataset.lbProtectionKeys || '[]'
            );

            const updates = Object.fromEntries(
              keys.map((key) => [key, 0])
            );

            result = await request('cart/update.js', {
              updates
            });
          } else {
            result = await request('cart/add.js', {
              items: [
                {
                  id: Number(button.dataset.lbProtection),
                  quantity: 1
                }
              ]
            });
          }
        } else {
          result = await request('cart/change.js', {
            id: button.dataset.lbKey,
            quantity: Number(button.dataset.lbQuantity)
          });
        }

        changed = true;

        if (button.hasAttribute('data-lb-protection')) {
          window.lbSetGuaranteeOptOut(
            button.getAttribute('aria-checked') === 'true'
          );
        }

        html = result.sections?.[sectionId];

        if (typeof result.item_count === 'number') {
          cart = result;
        } else {
          const cartResponse = await fetch(root + 'cart.js', {
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!cartResponse.ok) {
            throw new Error(
              'Não foi possível carregar o total atualizado.'
            );
          }

          cart = await cartResponse.json();
        }

        if (
          cart.items.length > 0 &&
          protectionProductId &&
          cart.items.every(
            (item) => item.product_id === protectionProductId
          )
        ) {
          const updates = Object.fromEntries(
            cart.items.map((item) => [item.key, 0])
          );

          cart = await request('cart/update.js', {
            updates
          });

          html = cart.sections?.[sectionId];
        }

        if (!html) {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', sectionId);

          const sectionResponse = await fetch(url);

          if (!sectionResponse.ok) {
            throw new Error(
              'Não foi possível atualizar a exibição do carrinho.'
            );
          }

          html = await sectionResponse.text();
        }

        const parsed = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const updated = parsed.querySelector('#cart-drawer');

        if (!updated) {
          throw new Error(
            'Não foi possível atualizar a exibição do carrinho.'
          );
        }

        drawer.innerHTML = updated.innerHTML;

        drawer.classList.toggle(
          'drawer--center-body',
          cart.item_count === 0
        );
      } catch (error) {
        const message = drawer.querySelector(
          '.lb-cart__error'
        );

        if (message) {
          message.textContent = changed
            ? 'O carrinho foi alterado, mas a atualização da tela falhou. Recarregue a página para conferir o total.'
            : error.message ||
              'Não foi possível atualizar o carrinho. Tente novamente.';

          message.hidden = false;
        }
      } finally {
        drawer.dataset.lbBusy = 'false';
        drawer.removeAttribute('aria-busy');

        controls.forEach((control) => {
          if (control.isConnected) {
            control.disabled = originalDisabled.get(control);
          }
        });
      }

      if (cart && Array.isArray(cart.items)) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              cart,
              baseEvent: 'line-item:change'
            }
          })
        );
      }

      window.lbQueueGuarantee?.();
    });
  }

  if (!window.lbGuaranteeAutoBound) {
    window.lbGuaranteeAutoBound = true;
    window.lbGuaranteeAutoFailed = false;

    window.lbEnsureGuarantee = async () => {
      const drawer = document.querySelector('#cart-drawer');

      if (!drawer || drawer.dataset.lbBusy === 'true') return;

      if (drawer.classList.contains('drawer--center-body')) {
        window.lbSetGuaranteeOptOut(false);
        window.lbGuaranteeAutoFailed = false;
        return;
      }

      const toggle = drawer.querySelector(
        '[data-lb-protection]'
      );

      if (
        !toggle ||
        toggle.disabled ||
        toggle.getAttribute('aria-checked') === 'true'
      ) {
        return;
      }

      if (!drawer.querySelector('.lb-cart__item')) return;

      if (
        window.lbGuaranteeOptOut ||
        window.lbGuaranteeAutoFailed
      ) {
        return;
      }

      drawer.dataset.lbBusy = 'true';
      drawer.setAttribute('aria-busy', 'true');

      const controls = drawer.querySelectorAll(
        '[data-lb-key], [data-lb-protection], button[name="checkout"]'
      );

      const originalDisabled = new Map();

      controls.forEach((control) => {
        originalDisabled.set(control, control.disabled);
        control.disabled = true;
      });

      const root = window.Shopify?.routes?.root || '/';
      const sectionId = drawer.dataset.sectionId;

      let cart;
      let changed = false;

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(toggle.dataset.lbProtection),
                quantity: 1
              }
            ],
            sections: [sectionId],
            sections_url: window.location.pathname
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Não foi possível incluir a garantia.'
          );
        }

        changed = true;

        const cartResponse = await fetch(root + 'cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        });

        if (!cartResponse.ok) {
          throw new Error(
            'Não foi possível atualizar o total.'
          );
        }

        cart = await cartResponse.json();

        let html = result.sections?.[sectionId];

        if (!html) {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', sectionId);

          const sectionResponse = await fetch(url);

          if (!sectionResponse.ok) {
            throw new Error(
              'Não foi possível atualizar a exibição do carrinho.'
            );
          }

          html = await sectionResponse.text();
        }

        const parsed = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const updated = parsed.querySelector('#cart-drawer');

        if (!updated) {
          throw new Error(
            'Não foi possível atualizar a exibição do carrinho.'
          );
        }

        drawer.innerHTML = updated.innerHTML;

        drawer.classList.toggle(
          'drawer--center-body',
          cart.item_count === 0
        );
      } catch (error) {
        window.lbGuaranteeAutoFailed = true;

        const message = drawer.querySelector(
          '.lb-cart__error'
        );

        if (message) {
          message.textContent = changed
            ? 'A garantia foi adicionada. Recarregue a página para conferir o total atualizado.'
            : error.message ||
              'Não foi possível incluir a garantia. Você pode ativá-la no botão acima.';

          message.hidden = false;
        }
      } finally {
        drawer.dataset.lbBusy = 'false';
        drawer.removeAttribute('aria-busy');

        controls.forEach((control) => {
          if (control.isConnected) {
            control.disabled = originalDisabled.get(control);
          }
        });
      }

      if (cart && Array.isArray(cart.items)) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              cart,
              baseEvent: 'line-item:change'
            }
          })
        );
      }
    };

    let queued = false;

    window.lbQueueGuarantee = () => {
      if (queued) return;

      queued = true;

      queueMicrotask(() => {
        queued = false;
        window.lbEnsureGuarantee();
      });
    };

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        const target = record.target;

        if (
          target.nodeType === 1 &&
          target.closest?.('#cart-drawer')
        ) {
          if (
            target.closest(
              '.lb-cart__timer, .lb-cart__error'
            )
          ) {
            continue;
          }

          window.lbQueueGuarantee();
          return;
        }

        for (const node of record.addedNodes) {
          if (
            node.nodeType === 1 &&
            (
              node.id === 'cart-drawer' ||
              node.querySelector?.('#cart-drawer')
            )
          ) {
            window.lbQueueGuarantee();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.documentElement.addEventListener(
      'cart:change',
      window.lbQueueGuarantee
    );

    document.documentElement.addEventListener(
      'variant:add',
      () => {
        window.lbGuaranteeAutoFailed = false;
        window.lbQueueGuarantee();
      }
    );

    window.lbQueueGuarantee();
  }

  } catch(e) { console.error(e); }
})();
})();
